export const url = "https://savethechildrenmx.org";

export const buscador = new URLSearchParams(window.location.search);

var formData = new FormData();

formData.append("id",buscador.get("id"))


var interval_id;

function createSplitelement(element){
    var container = document.createElement("div")
    container.classList.add("split-rows-container")

    var left_container = document.createElement("div");
    left_container.classList.add("left-tables-container")

    var obj = document.createElement("div")
    obj.classList.add("obj")

    var right_container = document.createElement("div");
    right_container.classList.add("right-tables-container")

    var tables_container = document.createElement("div")
    tables_container.classList.add("tables-row");
    tables_container.id = "tables-row-"+element.type+"-"+element.section;

    if (element.type.localeCompare("left") === 0){
        left_container.appendChild(tables_container)
    }else{
        right_container.appendChild(tables_container)
    }

    container.appendChild(left_container)
    container.appendChild(obj)
    container.appendChild(right_container)
    document.querySelector(".map").appendChild(container)
}

function createTable(element,last_element){
    var left_container = last_element.querySelector(".left-tables-container");
    var right_container = last_element.querySelector(".right-tables-container");

    var tables_container = document.createElement("div")
    tables_container.classList.add("tables-row");
    tables_container.id = "tables-row-"+element.type+"-"+element.section;

    if (element.type.localeCompare("left") === 0){
        left_container.appendChild(tables_container)
    }else{
        right_container.appendChild(tables_container)
    }
}

function createMap(){
    var container = document.querySelector(".map");

    if (container) {
        fetch(url+"/getEventSections", {
            method: 'POST',
            body: formData
        }).then(resp => {
            if (resp.status === 200) {
                return resp.text()
            }
        }).then(txt => {
            var info = JSON.parse(txt)
            container.innerHTML="";

            info.forEach(element=>{
                if (element.type.localeCompare("single")===0){
                    var container = document.createElement("div");
                    container.classList.add("tables-row")
                    container.classList.add("single")
                    container.id = "row-"+element.section
                    document.querySelector(".map").appendChild(container)
                }else{
                    var last_element = document.querySelector(".map").lastElementChild

                    if (!last_element){
                        createSplitelement(element);
                    }else{
                        if (last_element.classList.contains("split-rows-container")){
                            createTable(element,last_element)
                        }else{
                            createSplitelement(element)
                        }
                    }
                }
            })
            getTables();
            updateSeatsStatus();
        })
        clearInterval(interval_id)
    }
}

async function getTables(){
    await fetch(url+"/getEventTables",{
        method:'POST',
        body: formData
    }).then(resp=>{
        if (resp.status === 200){
            return resp.text()
        }
    }).then(txt=>{
        var data = JSON.parse(txt)

        data.forEach(element=>{

            var mesa_container = document.createElement("div");
            mesa_container.classList.add("mesa_container");
            mesa_container.classList.add("live")

            var mesa = document.createElement("div")
            mesa.classList.add("mesa")
            mesa.classList.add("mesa-"+element.number);

            var mesa_number = document.createElement("div")
            mesa_number.classList.add("table_number")
            mesa_number.textContent = element.number

            mesa.appendChild(mesa_number)
            mesa_container.appendChild(mesa)

            if (element.position.localeCompare("single") != 0){
                document.querySelector("#tables-row-"+element.position+"-"+element.section).appendChild(mesa_container)
            }else{
                document.querySelector("#row-"+element.section).appendChild(mesa_container)
            }

        })
        getSeats()
    })
}

function getSeats(){
    fetch(url+"/getEventSeats",{
        method:'POST',
        body: formData
    }).then(resp=>{
        if (resp.status === 200){
            return resp.text()
        }
    }).then(txt=>{
        var data = JSON.parse(txt)

        data.forEach(element=>{
            var silla_container = document.createElement("div")
            silla_container.classList.add("silla_container")
            silla_container.classList.add("silla_container-"+element.asiento)

            var silla = document.createElement("div")
            silla.classList.add("silla")
            silla.classList.add("live")
            silla.classList.add("silla-"+element.asiento)


            silla_container.appendChild(silla)
            document.querySelector(".mesa-"+element.mesa).parentElement.appendChild(silla_container)

            setSeatColor(silla,element.status)
        })

        rotateSeats()
    })
}

function orderTables(){
    document.querySelectorAll(".tables-row").forEach(element=>{
        var width = element.clientWidth;
        var elements = element.querySelectorAll(".mesa_container")
        var size = (width * .9)/elements.length

        elements.forEach(container=>{
            container.style.width = size+"px"
            container.style.height = size+"px"
        })
    })

    verifyLanguage();
}

function verifyLanguage(){
    if (buscador.get("lang") != null && buscador.get("lang").localeCompare("en")==0){
        document.querySelector(".titulo-asientos").textContent="Seats"
        document.querySelector(".label-asientos").textContent="Choose the seats you want to buy"
        document.querySelector(".btn-1").textContent="Find seats"
        document.querySelector(".btn-2").textContent="Continue"

        document.querySelector(".pantalla").textContent="stage/screen"
        document.querySelector(".personal-data").textContent="Personal information"
        document.querySelector(".detalles").textContent="Details"
        document.querySelector(".label-table").textContent="Table"
        document.querySelector(".label-seats").textContent="Seats"
        document.querySelector(".label-total").textContent="Total"
        document.querySelector(".label-nombre").textContent="First Name"
        document.querySelector(".label-apellido-paterno").textContent="Last Name"
        document.querySelector(".label-apellido-materno").style.display="none";
        document.querySelector(".label-apellido-materno").nextSibling.style.display="none";
        document.querySelector(".label-apellido-materno").nextSibling.classList.add("is-valid")
        document.querySelector(".label-apellido-materno").nextSibling.querySelector("input").value = "NO aplica"
        document.querySelector(".label-correo").textContent="Email"
        document.querySelector(".label-telefono").textContent="Mobile Phone"
        document.querySelector(".banco").textContent="Telephone"
        document.querySelector(".tarjeta").placeholder="Card number"
        document.querySelector(".m-exp").placeholder="Expiry month"
        document.querySelector(".a-exp").placeholder="Expiry Year"
        document.querySelector(".titular").placeholder="Cardholder Name"
        document.querySelector(".btn-f").textContent="Pay and finish"

        document.querySelector(".legend-1").textContent=" We've got a problem with your card"
        document.querySelector(".legend-2").textContent=" The reason:"
        document.querySelector(".legend-3").textContent="I prefer to be called "
        document.querySelector(".again").textContent="Try again"

        document.querySelector(".legend-4").textContent="Only one more step!"
        document.querySelector(".legend-5").textContent="Your card requests authorization from your bank."
        document.querySelector(".legend-6").textContent="Please complete this step and then press the verify button. "
        document.querySelector(".legend-7").textContent="The popup window will be displayed in 10 seconds. "
        document.querySelector(".legend-7").textContent="The popup window will be displayed in 10 seconds. "
        document.querySelector(".legend-8").textContent="Verify"

        document.querySelector(".legend-9").textContent="Successful payment"
        document.querySelector(".legend-10").textContent="We will send you an email confirming your payment. "
        document.querySelector(".legend-11").textContent="I want an invoice . "
        document.querySelector(".legend-12").textContent="I don't want an invoice. "
        document.querySelector(".legend-13").textContent="Please wait. "
        document.querySelector(".legend-14").textContent="Thank you! "

    }
}

function rotateSeats(){
    document.querySelectorAll(".mesa").forEach(element=>{
        var sillas = element.parentElement.querySelectorAll(".silla_container");
        var deg = 360/sillas.length;

        var grados = 0;

        sillas.forEach(element=>{
            element.style.transform = "rotateZ("+grados+"deg)";
            grados+=deg;
        })
    })

    document.getElementById("lugares").removeAttribute("disabled")
    document.querySelector(".step-1 button").setAttribute("disabled","")
    document.querySelector(".loading-container").classList.add("hidden-alert")
    document.querySelector("body").classList.remove("lock")

    orderTables();
}

function setSeatColor(element, status){
    switch (status){
        case 'disponible':
            element.style.backgroundColor="#0FD521";
            break;
        case 'apartado':
            element.style.backgroundColor="#EFD516";
            break;
        case 'comprado':
            element.style.backgroundColor="#ff0000";
            break;
        case 'bloqueado':
            element.style.backgroundColor="#001f3f";
            break;
    }
}


function updateSeatsStatus(seats = -1){
    fetch(url+"/getSeatsStatus",{
        method: 'POST',
        body:formData
    }).then(resp=>{
        if (resp.status===200){
            return resp.text()
        }
    }).then(txt=>{

        document.querySelectorAll(".mesa_container").forEach(element=>{
            element.classList.add("full")
            element.setAttribute("disabled","disabled")
        })

    })
}

export default function startMapping(){
    localStorage.clear()
    interval_id = setInterval(createMap,2000)
    setTimeout(()=>{
        if (buscador.get("owner")==null){
            document.querySelector(".input-group.pwd").remove()
        }
    },100)
}




// WEBPACK FOOTER //
// ./src/plugins/mapListener.js